// extracted by mini-css-extract-plugin
module.exports = {"contactInfoWrapper":"styles-module--contact-info-wrapper--3h5vb","fadeIn":"styles-module--fadeIn--2HbS1","slideInDown":"styles-module--slideInDown--2OXWs"};